import React, { Component } from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
export function GestionProfesional() {
  return <section className="py-20 bg-charcoal border-y border-white/10 mt-20 pt-[52px] pb-[52px]" data-id="element-157">
      <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8 pt-[0px] pb-[0px] pl-[24px] pr-[24px]" data-id="element-158">
        <div className="text-center mb-16" data-id="element-159">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white" data-id="element-160">
            🕊️ ¿QUÉ AGREGA EL PACK FAMILIAR COMPLETO?
          </h2>
          <p className="text-xl text-gray-300 font-medium" data-id="element-161">
            Descanso Profundo Para Adolescentes + Descanso Profundo Para Adultos
          </p>
        </div>

        {/* Adolescentes */}
        <div className="bg-night-light rounded-2xl shadow-md border border-white/10 overflow-hidden mb-12" data-id="element-162">
          <div className="bg-night-lighter text-white p-6 md:p-8" data-id="element-163">
            <h3 className="text-2xl font-serif font-bold flex items-center gap-3" data-id="element-164">
              📱 DESCANSO PROFUNDO PARA ADOLESCENTES
            </h3>
            <p className="text-gold mt-2 font-medium" data-id="element-165">(50 páginas)</p>
          </div>

          <div className="p-6 md:p-8" data-id="element-166">
            <div className="overflow-x-auto mb-8" data-id="element-167">
              <table className="w-full text-sm text-left min-w-[600px]" data-id="element-168">
                <thead className="bg-night-lighter text-white font-bold" data-id="element-169">
                  <tr data-id="element-170">
                    <th className="px-4 py-3 rounded-tl-lg" data-id="element-171">
                      Situación en casa
                    </th>
                    <th className="px-4 py-3 text-red-500" data-id="element-172">
                      ❌ Sin Pack Familiar
                    </th>
                    <th className="px-4 py-3 text-green-500 rounded-tr-lg" data-id="element-173">
                      ✅ Con Pack Familiar
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-white/10" data-id="element-174">
                  {[['Tu adolescente no puede dormirse antes de la 1 AM', 'Le decís que apague el celular y hay pelea', 'Protocolo Digital + Cronotipos. Sabe por qué pasa y cómo manejarlo'], ['El adolescente está destruido los lunes', 'Le pedís que "se organice"', 'Protocolo Anti Jet Lag Social. Fin del lunes zombie'], ['El adolescente no rinde en el colegio aunque estudia', 'Creés que no estudia suficiente', 'El sueño REM que pierde cada noche le roba el 30% del aprendizaje. Ahora tenés la solución']].map((row, i) => <tr key={i} className="hover:bg-white/5" data-id="element-175">
                      <td className="px-4 py-3 font-medium text-gray-100" data-id="element-176">
                        {row[0]}
                      </td>
                      <td className="px-4 py-3 text-gray-300" data-id="element-177">{row[1]}</td>
                      <td className="px-4 py-3 text-gray-100 font-medium" data-id="element-178">
                        {row[2]}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>

            <div className="bg-night-lighter rounded-xl p-6 border border-white/10" data-id="element-179">
              <h4 className="font-bold text-lg mb-4 flex items-center gap-2 text-white" data-id="element-180">
                <CheckCircle2 className="text-green-500" data-id="element-181" /> EL PACK INCLUYE:
              </h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-182">
                {['La neurología del retraso de fase puberal — por qué tu hijo no puede dormirse temprano aunque quiera', 'El Protocolo Digital de 4 Zonas — sin pelea, sin imposición', 'El Contrato de Desconexión para firmar con tu hijo', 'Los cronotipos y el horario de estudio ideal según la biología de tu hijo', 'La Bitácora de Sueño y Energía para que él mismo monitoree', 'Plan de 30 días de transformación'].map((item, i) => <div key={i} className="flex items-start gap-2 text-sm text-gray-200" data-id="element-183">
                    <CheckCircle2 className="w-4 h-4 text-gold shrink-0 mt-0.5" data-id="element-184" />
                    <span data-id="element-185">{item}</span>
                  </div>)}
              </div>
            </div>
          </div>
        </div>

        {/* Adultos */}
        <div className="bg-night-light rounded-2xl shadow-md border border-white/10 overflow-hidden" data-id="element-186">
          <div className="bg-night-lighter text-white p-6 md:p-8" data-id="element-187">
            <h3 className="text-2xl font-serif font-bold flex items-center gap-3" data-id="element-188">
              ☕ DESCANSO PROFUNDO PARA ADULTOS
            </h3>
            <p className="text-gold mt-2 font-medium" data-id="element-189">(50 páginas)</p>
          </div>

          <div className="p-6 md:p-8" data-id="element-190">
            <div className="overflow-x-auto mb-8" data-id="element-191">
              <table className="w-full text-sm text-left min-w-[600px]" data-id="element-192">
                <thead className="bg-night-lighter text-white font-bold" data-id="element-193">
                  <tr data-id="element-194">
                    <th className="px-4 py-3 rounded-tl-lg" data-id="element-195">
                      Situación en casa
                    </th>
                    <th className="px-4 py-3 text-red-500" data-id="element-196">
                      ❌ Sin Pack Familiar
                    </th>
                    <th className="px-4 py-3 text-green-500 rounded-tr-lg" data-id="element-197">
                      ✅ Con Pack Familiar
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-white/10" data-id="element-198">
                  {[['Vos ya no podés dormir aunque los chicos duerman bien', 'Te aguantás', 'Reset del Sistema Nervioso. 5 técnicas específicas para adultos con hiper-vigilancia parental'], ['Te despertás entre las 2 y las 4 AM sin razón', 'Mirás el celular y empeora', 'Protocolo de las 4 AM. Sabés exactamente qué hacer'], ['Te acostás agotado/a pero tu mente no para', 'Tomás algo para dormir', 'La Caja de Preocupaciones + Vaciado Mental Ejecutivo. Esta noche']].map((row, i) => <tr key={i} className="hover:bg-white/5" data-id="element-199">
                      <td className="px-4 py-3 font-medium text-gray-100" data-id="element-200">
                        {row[0]}
                      </td>
                      <td className="px-4 py-3 text-gray-300" data-id="element-201">{row[1]}</td>
                      <td className="px-4 py-3 text-gray-100 font-medium" data-id="element-202">
                        {row[2]}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>

            <div className="bg-night-lighter rounded-xl p-6 border border-white/10" data-id="element-203">
              <h4 className="font-bold text-lg mb-4 flex items-center gap-2 text-white" data-id="element-204">
                <CheckCircle2 className="text-green-500" data-id="element-205" /> EL PACK INCLUYE:
              </h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-206">
                {['La neurología del agotamiento parental — por qué años de noches interrumpidas reprogramaron tu sistema nervioso', 'El Reset del Sistema Nervioso — 5 técnicas con evidencia científica', 'El Protocolo de Descompresión Post-Trabajo — cómo separar el cerebro laboral del cerebro de descanso', 'La Ingeniería del Dormitorio Adulto — las 7 variables que determinan la calidad de tu sueño', 'El Protocolo de las 4 AM — qué hacer exactamente cuando tu mente se enciende de madrugada', 'Plan de 21 días de recuperación completo'].map((item, i) => <div key={i} className="flex items-start gap-2 text-sm text-gray-200" data-id="element-207">
                    <CheckCircle2 className="w-4 h-4 text-gold shrink-0 mt-0.5" data-id="element-208" />
                    <span data-id="element-209">{item}</span>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}